import { render, staticRenderFns } from "./MConfirm.vue?vue&type=template&id=50aeb376"
import script from "./MConfirm.vue?vue&type=script&lang=js"
export * from "./MConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports